import MessagingTemplateActions from './messagingTemplateActions.container';

export default MessagingTemplateActions;
